/**
 * Formata código hierárquico para exibição (ex.: 1 -> 01, 1.2 -> 01.02).
 * Vírgula é tratada como separador, igual ao ponto.
 *
 * @param {string|number} codigo
 * @returns {string}
 */
export function formatCentroCustoCodigoDisplay(codigo) {
  if (codigo == null || codigo === '') return '';
  const s = String(codigo).trim().replace(/,/g, '.');
  const parts = s.split('.').filter((p) => p.length > 0);
  return parts
    .map((part) => {
      const n = parseInt(part, 10);
      return Number.isNaN(n) ? part : String(n).padStart(2, '0');
    })
    .join('.');
}
